<template>
<!-- list模式周视图 -->
  <div class="list">
    <div class="list-every">
       <template-day-list v-for="(item,index) in eventModesList" :key="index" class="list-item" :style="`width:${headWith+2}px`" :eventDayList='item' :dataIndex='index' @createEvent='createEvent'  @fillCreateBox='fillCreateBox' :curDate='curDate' :TimeQuantum='TimeQuantum'></template-day-list>
    </div>
  </div>
</template>

<script>
import TemplateDayList from './TemplateDayList.vue'
export default {
  components: { TemplateDayList },
  // eventModesList 日信息
  // headWith 每天列的宽度
  // curDate  当天的开始时间
  // TimeQuantum 选择当天的时间段
  props: ['eventModesList', 'headWith', 'curDate', 'TimeQuantum'],
  data () {
    return {
    }
  },
  methods: {
    // 点击图标编辑
    ClickIconCompile (item, e) {
      // 打开创建编辑框
      this.$emit('popupCreateBox', {
        e,
        event: item,
        type: 1
      })
    },
    // 点+创建事件
    createEvent (param) {
      this.$emit('createEvent', param)
    },
    // 点击事件编辑弹框
    fillCreateBox (e) {
      this.$emit('fillCreateBox', e)
    }
  }
}
</script>

<style lang="less" scoped>
.list{
  overflow-y: auto;
  height: calc(78vh);
  .list-every{
    height: fit-content;
    min-height: 722px;
    display: flex;
    .list-item{
        border-left:1px solid #252525 ;
        .item{
          height: 28px;
          border-radius: 5px;
          position: relative;
          .IconWrap {
            p {
              width: 20px;
              height: 20px;
              background: #67aa25;
              text-align: center;
              line-height: 20px;
              margin-right: 2px;
              border-radius: 3px;
              i{
                color:#252525 ;
              }
            }
          }
        }
      }
  }

}
</style>>
